import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {catchError, firstValueFrom, Observable} from 'rxjs';
import {BasedataService} from '../shared/basedata.service';
import {ActivityData} from './activity';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {MultiActivityData} from './multi-activity';
import {ActivityEditData} from '@docma-mm-core/activity/activity-edit';
import {map} from 'rxjs/operators';
import {FaultData} from '@docma-mm-core/fault/fault-data';
import {ActivityPatchModeEnum} from '@docma-mm-core/activity/activity-patch-mode.enum';
import {SendLog} from '@docma-mm-core/activity/send-log';
import {ToId} from '@docma-mm-core/api.functions';

@Injectable()
export class ActivityApiService extends BasedataService {

  private readonly faultUrl = '/faults';
  private readonly activityUrl = '/activities';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getFaultActivityUrl(faultId: number) {
    return super.getFullUrl(this.faultUrl + '\\' + faultId + this.activityUrl);
  }

  private getActivityUrl() {
    return super.getFullUrl(this.activityUrl);
  }

  // // get activities by fault
  // getFaultActivities(faultId: number): Observable<ActivityData[]> {
  //   const endpoint = this.getFaultActivityUrl(faultId);
  //   return this.http
  //     .get<ActivityData[]>(endpoint, { headers: this.getHeaders() })
  //     .pipe(catchError(e  => this.handleError(e)));
  // }
  //
  // // get activity by id
  // getActivityById(activityId: number): Observable<ActivityData> {
  //   const endpoint = this.getActivityUrl() + '/' + activityId;
  //   return this.http
  //     .get<ActivityData>(endpoint, { headers: this.getHeaders() })
  //     .pipe(catchError(e  => this.handleError(e)));
  // }

  async getActivity(activityUid: string) {
    const uid = ToId(activityUid);

    const endpoint = this.getActivityUrl() + '/' + uid;
    const loaded = await firstValueFrom(this.http
      .get<ActivityData>(endpoint, { headers: this.getHeaders() })
        .pipe(catchError(e  => this.handleError(e))));

    return loaded;
  }

  // create new activity by fault
  createFaultActivity(faultId: number, activity: ActivityData): Observable<ActivityData> {
    const endpoint = this.getFaultActivityUrl(faultId);
    return this.http
      .post<ActivityData>(endpoint, JSON.stringify(activity), { headers: this.getHeaders() })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // create new activity for faults
  getAffectedActivities(project: {mydocmaUid: string, projectId: number}, activityEdit: ActivityEditData): Observable<ActivityEditData> {
    const endpoint = super.getFullUrl(this.faultUrl + this.activityUrl + '/patch/affected');
    let httpParams = new HttpParams();
    httpParams = httpParams.set('projectId', project.projectId);
    return this.http
      .post<{PatchData: ActivityData, PatchMode: ActivityPatchModeEnum, Activities: { Id: number, UniqueId: string, Fault: FaultData }[], ActivitiesOfGroup: { Id: number, UniqueId: string, Fault: FaultData }[]}>(endpoint, JSON.stringify(activityEdit), { headers: this.getHeaders(), params: httpParams })
      .pipe(
        map(x => {
          var res = new ActivityEditData(x.PatchData, x.PatchMode, x.Activities, x.ActivitiesOfGroup);
          return res;
        }),
        catchError(e  => this.handleError(e)));
  }

  // patch activities of faults
  patchActivities(project: {mydocmaUid: string, projectId: number}, activityEdit: ActivityEditData): Observable<ActivityEditData> {
    const endpoint = super.getFullUrl(this.faultUrl + this.activityUrl + '/patch');
    let httpParams = new HttpParams();
    httpParams = httpParams.set('projectId', project.projectId);
    return this.http
      .post<{PatchData: ActivityData, PatchMode: ActivityPatchModeEnum, Activities: { Id: number, UniqueId: string, Fault: FaultData }[], ActivitiesOfGroup: { Id: number, UniqueId: string, Fault: FaultData }[]}>(endpoint, JSON.stringify(activityEdit), { headers: this.getHeaders(), params: httpParams })
      .pipe(
        map(x => {
          var res = new ActivityEditData(x.PatchData, x.PatchMode, x.Activities, x.ActivitiesOfGroup);
          return res;
        }),
        catchError(e  => this.handleError(e)));
  }

  // create new activity for faults
  createActivityGroup(project: {mydocmaUid: string, projectId: number}, multiActivityData: MultiActivityData): Observable<MultiActivityData> {
    const endpoint = super.getFullUrl(this.faultUrl + this.activityUrl);
    let httpParams = new HttpParams();
    httpParams = httpParams.set('projectId', project.projectId);
    return this.http
      .post<MultiActivityData>(endpoint, JSON.stringify(multiActivityData), { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

  // update existing activity
  updateActivity(activityId: any, activity: ActivityData): Observable<ActivityData> {
    const endpoint = this.getActivityUrl() + '/' + ToId(activityId);
    return this.http
      .put<ActivityData>(endpoint, JSON.stringify(activity), { headers: this.getHeaders() })
      .pipe(
        map( act => {
          return new ActivityData(act);
        }),
        catchError((e) => this.handleError(e)));
  }

  deleteActivity(actividyId: number, deleteGroupEnabled: boolean = false) {
    const endpoint = this.getActivityUrl();
    let httpParams = new HttpParams();
    httpParams = httpParams.set('IsDeleteActivityGroupsEnabled', deleteGroupEnabled + '');

    return this.http.delete(endpoint, {
       body: [actividyId],
      headers: this.getHeaders(),
      params:  httpParams
    }).pipe(
        map( modifiedOn => {
          if (modifiedOn?.toString()) {
            return new Date(modifiedOn?.toString());
          }
          return;
        }),
        catchError((e) => this.handleError(e)));
  }
  getSendLog(activity: ActivityData): Observable<SendLog> {
    const endpoint = this.getActivityUrl() + '/' + activity.Id + '/sendlog/' + activity.Email.MessageGuid;
    return this.http
      .get<SendLog>(endpoint, { headers: this.getHeaders() })
      .pipe(
        map( log => {
          return log;
        }),
        catchError((e) => this.handleError(e)));
  }

}
